var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("ExplainCard", {
        attrs: {
          explainTitle: "价格监控配置说明",
          explainText:
            "配置商品价格监控规则，包括与京东、淘宝等平台的价格对比规则，系统将自动监测并发送预警通知。支持全局规则和特定商品规则的灵活设置。",
        },
      }),
      _c(
        "el-card",
        {
          staticClass: "ivu-mt mt14",
          attrs: {
            bordered: false,
            shadow: "never",
            "body-style": { paddingTop: "10px" },
          },
        },
        [
          _c(
            "el-tabs",
            {
              staticClass: "list-tabs mb5",
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c("el-tab-pane", {
                attrs: { label: "特定商品规则", name: "specificProductRules" },
              }),
            ],
            1
          ),
          _vm.activeName === "specificProductRules"
            ? _c("SpecificProductRules", { ref: "specificProductRulesRef" })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }